// opervex-frontend/src/components/ConfirmationModal/ConfirmationProvider.js

import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import ConfirmService from "./ConfirmService";

const ConfirmationProvider = ({ children }) => {
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    ConfirmService.onConfirm(({ title, message, onlyAlert, resolve }) => {
      setModalData({ title, message, onlyAlert, resolve });
    });
  }, []);

  const handleConfirm = () => {
    modalData.resolve(true);
    setModalData(null);
  };

  const handleCancel = () => {
    modalData.resolve(false);
    setModalData(null);
  };

  return (
    <>
      {children}
      <Modal show={!!modalData} onHide={handleCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalData?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Array.isArray(modalData?.message) ? (
            modalData.message.map((item, index) => <div key={index} dangerouslySetInnerHTML={{ __html: item.message || "" }} />)
          ) : (
            <div dangerouslySetInnerHTML={{ __html: modalData?.message || "" }} />
          )}
        </Modal.Body>
        <Modal.Footer>
          {modalData?.onlyAlert ? (
            <Button variant="primary" onClick={handleConfirm}>
              Ok
            </Button>
          ) : (
            <>
              <Button variant="secondary" onClick={handleCancel}>
                Não
              </Button>
              <Button variant="primary" onClick={handleConfirm}>
                Sim
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmationProvider;
